import { Modal, StackModalProps } from 'almanac-ui/Modal'
import { Trash2 } from 'blaze-ui/icons'
import { Button } from 'components/Button'

export interface Props extends StackModalProps {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export const DeleteConfirmModal = ({ onCancel, onConfirm, onPressOutside }: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title="Are you sure you want to delete this page?" />
    <Modal.Content>
      All content on this page will be lost. Make sure to copy anything you want to preserve.
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button onPress={onCancel} size="xl" variant="tertiary">
          Cancel
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button onPress={onConfirm} size="xl" variant="primary" frontIcon={Trash2}>
          Delete page
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
